import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

export const OsTagSection = styled.div<{ cnt: number; gap: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cnt}, 1fr);
  gap: ${(props) => props.gap}px;
  width: 100%;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    display: flex;
    flex-direction: column;
  }
`;

export const OsServerImg = styled.img`
  width: 100%;
  border-radius: 32px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background-color: #f8f8f8;

  aspect-ratio: 1232/500;

  object-fit: contain;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    aspect-ratio: 912/400;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    aspect-ratio: 361/360;
  }
`;

export const ShowMore = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  height: auto;
  cursor: pointer;
  max-width: 100%;
`;
